@let currentLanguage = this.currentLanguage();
@let reviewUrl = this.reviewUrl();
@let surveyUrl = this.surveyUrl();

@let isFrench = currentLanguage === 'fr-CA';

<div class="content" [class.fr]="isFrench">
  @if (isFrench) {
    <img
      src="/images/service-center-sections/more-review-content-fr.svg"
      width="758"
      height="466"
      alt="Review Content"
    />
  } @else {
    <img
      src="/images/service-center-sections/more-review-content-en.svg"
      width="712"
      height="515"
      alt="Review Content"
    />
  }
</div>

<div class="links">
  @if (reviewUrl) {
    <div class="col">
      <app-qrcode
        class="qr-code"
        variant="red"
        [content]="reviewUrl"
        [size]="400"
      />
      <div class="description">
        @if (isFrench) {
          Avis Google
        } @else {
          Leave us a Google Review
        }
      </div>
    </div>
  }

  @if (surveyUrl) {
    <div class="col">
      <app-qrcode
        class="qr-code"
        variant="red"
        [content]="surveyUrl"
        [size]="400"
      />
      <div class="description">
        @if (isFrench) {
          <span>S</span>ondage
        } @else {
          Fill out our<br/> guest survey
        }
      </div>
    </div>
  }
</div>
